import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 28, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 25 25' fill={fillColor} className={className}>
      <g>
        <g transform='translate(-30.000000, -321.000000)'>
          <g transform='translate(31.000000, 322.000000)'>
            <g id='Stroke-999'>
              <path d='M7.5,4.5c-3.9,0-8-0.8-8-2.5s4.1-2.5,8-2.5s8,0.8,8,2.5S11.4,4.5,7.5,4.5z M7.5,0.5c-4.6,0-7,1.1-7,1.5 s2.4,1.5,7,1.5c4.6,0,7-1.1,7-1.5S12.1,0.5,7.5,0.5z' />
            </g>
            <g id='Stroke-1000'>
              <path d='M7.5,7.5c-3.9,0-8-0.8-8-2.5V2c0-0.3,0.2-0.5,0.5-0.5S0.5,1.7,0.5,2v3c0,0.4,2.4,1.5,7,1.5 c4.6,0,7-1.1,7-1.5V2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C15.5,6.7,11.4,7.5,7.5,7.5z' />
            </g>
            <g id='Stroke-1001'>
              <path d='M7.5,10.5c-3.9,0-8-0.8-8-2.5V5c0-0.3,0.2-0.5,0.5-0.5S0.5,4.7,0.5,5v3c0,0.4,2.4,1.5,7,1.5 c4.6,0,7-1.1,7-1.5V5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C15.5,9.7,11.4,10.5,7.5,10.5z' />
            </g>
            <g id='Stroke-1002'>
              <path d='M15.5,17.5c-3.9,0-8-0.8-8-2.5s4.1-2.5,8-2.5c3.9,0,8,0.8,8,2.5S19.4,17.5,15.5,17.5z M15.5,13.5 c-4.6,0-7,1.1-7,1.5s2.4,1.5,7,1.5c4.6,0,7-1.1,7-1.5S20.1,13.5,15.5,13.5z' />
            </g>
            <g id='Stroke-1003'>
              <path d='M15.5,20.5c-3.9,0-8-0.8-8-2.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3c0,0.4,2.4,1.5,7,1.5 c4.6,0,7-1.1,7-1.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C23.5,19.7,19.4,20.5,15.5,20.5z' />
            </g>
            <g id='Stroke-1004'>
              <path d='M15.5,23.5c-3.9,0-8-0.8-8-2.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3c0,0.4,2.4,1.5,7,1.5 c4.6,0,7-1.1,7-1.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C23.5,22.7,19.4,23.5,15.5,23.5z' />
            </g>
            <g id='Stroke-1005'>
              <path d='M7.5,13.5c-3.9,0-8-0.8-8-2.5V8c0-0.3,0.2-0.5,0.5-0.5S0.5,7.7,0.5,8v3c0,0.4,2.4,1.5,7,1.5 c4.6,0,7-1.1,7-1.5V8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C15.5,12.7,11.4,13.5,7.5,13.5z' />
            </g>
            <g id='Stroke-1006'>
              <path d='M8,16.5H7.5c-3.9,0-8-0.8-8-2.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3c0,0.4,2.4,1.5,7,1.5H8 c0.3,0,0.5,0.2,0.5,0.5S8.3,16.5,8,16.5z' />
            </g>
            <g id='Stroke-1007'>
              <path d='M8,19.5H7.5c-3.9,0-8-0.8-8-2.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3c0,0.4,2.4,1.5,7,1.5H8 c0.3,0,0.5,0.2,0.5,0.5S8.3,19.5,8,19.5z' />
            </g>
            <g id='Stroke-1008'>
              <path d='M15,13.5c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2C15.5,13.3,15.3,13.5,15,13.5z' />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
